<div *ngIf="navigationElement" class="main advisor" [class.active]="navigationElement.isActive">
  <a (click)="showOverlay = !showOverlay" class="show-overlay">
    <span class="show-overlay" [innerHTML]="navigationElement.textPrefix + 'name' | translate"></span>
  </a>
  <div class="overlay" *ngIf="showOverlay">
    <p [innerHTML]="navigationElement.textPrefix + 'description' | translate"></p>
    <a class="button inline-arrow-right" *ngIf="navigationElement.url" [href]="navigationElement.url" [innerHTML]="navigationElement.textPrefix + 'button' | translate"></a>
  </div>
</div>
